"use client";
import React, { useEffect, useState } from "react";
import {SDialogFC, SDialogProps} from "@/Master/SDialogFC/SDialogFC";
import {useDialogMethods} from "@/Master/SDialogFC/useDialogMethods";
import SDialogHeader from "@/app/_components/SDialogHeader/SDialogHeader";
import ComBG from "@/app/_components/ComBG/ComBG";
import PayRecordsUI from "@/app/(pay)/payRecords/PayRecordsUI";
import ScrollableContainer from "@/app/_components/ScrollableContainer/ScrollableContainer";

interface PaymentRecordsDialogProps extends SDialogProps {
    /** 额外参数 */
    // 可根据需要添加其他 Props，例如：errorMessage
}

export const PayRecordsDialogFC: React.FC<PaymentRecordsDialogProps> = (props) => {
    const { fcKey, onClose } = props;
    const { closeDialog } = useDialogMethods(fcKey);
    // ========== 模拟生命周期（类似 class 的 initData / onInit / onEnter） ==========
    // 用一个内部 state 控制对话框是否还可见
    const [isOpen, setIsOpen] = useState(true);
    useEffect(() => {
        return () => {
        };
    }, [props]);

    // ========== 按钮点击逻辑 ==========
    const onClickBack = () => {
        closeDialog();
        onClose?.();
    };

    // ========== 渲染 UI ==========
    return (
        <SDialogFC
            fcKey={fcKey}
            isOpen={isOpen}
            mode="Full"
            onClose={onClose}
        >
            <ComBG>
                <SDialogHeader
                    title="RECHARGE HISTORY"
                    onClickBack={onClickBack}
                />
                <ScrollableContainer>
                    <div className={"header_panel"}></div>
                    <PayRecordsUI/>
                </ScrollableContainer>
            </ComBG>
        </SDialogFC>
    );
};
